/**
 * Rezolvarea URL-urilor media (spec §5, storage S3).
 *
 * API-ul întoarce URL-uri presigned cu host intern `minio:9000` (nerezolvabil din
 * browser). În dev le rescriem la calea same-origin `/media/...`, servită de proxy-ul
 * Vite care păstrează antetul `Host: minio:9000` ca semnătura să rămână validă.
 * În producție se poate configura `VITE_MEDIA_ORIGIN` (ex. R2 public / CDN).
 */
const INTERNAL_MEDIA_HOST = 'http://minio:9000';
const MEDIA_ORIGIN = import.meta.env.VITE_MEDIA_ORIGIN as string | undefined;

export function resolveMediaUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith(INTERNAL_MEDIA_HOST)) {
    const rest = url.slice(INTERNAL_MEDIA_HOST.length);
    if (MEDIA_ORIGIN) return MEDIA_ORIGIN.replace(/\/$/, '') + rest;
    return '/media' + rest;
  }
  return url;
}
